import React from "react";
import { Button } from "ui/chakra/components/Button";

type AddToCartButtonProps = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  onClick,
}) => {
  return (
    <Button variant="solid" size="sm" onClick={onClick}>
      カートに入れる
    </Button>
  );
};
